var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 59,
    viewBox: "0 0 31 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 46.65C7.38 46.65 1 38.32 1 28.04C1 12 15.25 1.39001 15.25 1.39001C15.25 1.39001 29.5 12 29.5 28.04C29.5 36.07 25.61 42.92 20.15 45.53",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 46.65C7.38 46.65 1 38.32 1 28.04C1 12 15.25 1.39001 15.25 1.39001C15.25 1.39001 29.5 12 29.5 28.04C29.5 36.07 25.61 42.92 20.15 45.53",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 25.33V58.52",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5,
    height: 58.38,
    fill: "white",
    transform: "translate(0 0.140015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.5815b2783b320990d020ae5024090a4f.svg";
export { ForwardRef as ReactComponent };